import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { px, usd, maskText } from "./floorUtil";

const Row = ({ title, preview, testid, accent, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <section className="fc-panel" style={accent ? { borderColor: `${accent}55` } : {}} data-testid={testid}>
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center gap-2 px-3 py-2.5 text-left" data-testid={`${testid}-toggle`} aria-expanded={open}>
        <span className="fc-label shrink-0" style={accent ? { color: accent } : {}}>{title}</span>
        <span className="fc-num text-[10px] text-cyan-100/70 truncate flex-1 min-w-0">{preview}</span>
        <ChevronDown className={`w-4 h-4 text-cyan-300/50 shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-3 pb-3 space-y-1.5 max-h-72 overflow-y-auto">{children}</div>}
    </section>
  );
};

export const Vault = ({ items }) => {
  if (!items.length) return null;
  return (
    <Row title="The Vault" testid="floor-vault" accent="#2CF6B3" preview={items.map((v) => v.ticker).join(" · ")}>
      {items.map((v) => {
        const long = !/short|sell/i.test(v.dir || "");
        return (
          <div key={v.ticker} className="fc-vault-item flex items-center gap-2 fc-num text-[11px]" data-testid={`floor-vault-${v.ticker}`}>
            <b className="text-cyan-50">{v.ticker}</b>
            <span className={long ? "fc-gain" : "fc-loss"}>{long ? "LONG" : "SHORT"}</span>
            <span className="text-[#00F0FF]">{v.conf != null ? `${Math.round(v.conf)}%` : "—"}</span>
            <span className="ml-auto text-cyan-200/60">T <b className="fc-gain">{px(v.target)}</b> S <b className="fc-loss">{px(v.stop)}</b></span>
          </div>
        );
      })}
    </Row>
  );
};

const dot = { placed: "#2CF6B3", filled: "#2CF6B3", error: "#FF3D68", skipped: "#FBBF24" };
export const OrderLog = ({ orders, hidden }) => {
  const list = (orders || []).slice(0, 14);
  if (!list.length) return null;
  return (
    <Row title="Orders · fills" testid="floor-order-log" preview={`${list[0].symbol || ""} ${list[0].status || ""}`}>
      {list.map((o, i) => (
        <div key={i} className="fc-num text-[10px] flex flex-wrap items-center gap-x-2 py-0.5 border-b border-white/[0.04]" data-testid="floor-order-row">
          <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: dot[o.status] || "#00F0FF" }} />
          <b className="text-cyan-50">{o.symbol || "—"}</b>
          <span className="text-cyan-300/50 uppercase">{o.direction}</span>
          {!hidden && o.notional > 0 && <span className="text-cyan-200/60">{usd(o.notional, false, 0)}</span>}
          <span style={{ color: dot[o.status] || "#00F0FF" }}>{o.status}</span>
          <span className="ml-auto text-cyan-300/30">{o.created_at ? new Date(o.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : ""}</span>
          {o.error && <span className="basis-full text-rose-300/60 break-words">{maskText(o.error, hidden)}</span>}
        </div>
      ))}
    </Row>
  );
};
